import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import * as Sentry from "@sentry/angular";


if (environment.production) {
  enableProdMode();
  Sentry.init({
    dsn: "https://2fd64dd808143edef662f1c7624f3bb8@o4505148698394624.ingest.sentry.io/4505629714481152",
    integrations: [
      // Registers and configures the Tracing integration,
      // which automatically instruments your application to monitor its
      // performance, including custom Angular routing instrumentation
       Sentry.browserTracingIntegration(),
      
      // Registers the Replay integration,
      // which automatically captures Session Replays
      Sentry.replayIntegration(),
    ],
    attachStacktrace: true,
    environment: environment.name,
    tracesSampleRate: 0.2,
    // Session Replay
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    beforeSend(event, hint) {
      const err = hint?.originalException as any;
      if (err?.status === 0) return null;
      return event;
    },
  });
}


platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
